<ng-container *ngIf="product$ | async as product">
  <div
    class="container"
    *ngIf="
      product?.bomProductList?.length > 0 ||
      product?.nonCatalogBomProducts?.length > 0
    "
  >
    <div class="B-O-M">
      {{ "pdp.billMaterial" | cxTranslate }}
    </div>
    <div class="row B-O-M-header">
      <div class="col-md-1 center">
        <mat-checkbox
          class="check-box"
          [(ngModel)]="checked"
          (click)="changeCheck()"
          (change)="setAll($event.checked)"
        >
        </mat-checkbox>
      </div>
      <div [ngClass]="loggedIn ? 'col-md-3' : 'col-md-4'">
        {{ "pdp.product" | cxTranslate }}
      </div>
      <div [ngClass]="loggedIn ? 'col-md-2' : 'col-md-3'">
        {{ "pdp.prodQuantity" | cxTranslate }}
      </div>
      <div class="col-md-2 center" *ngIf="loggedIn">
        {{ "pdp.yourProdPrice" | cxTranslate }}
      </div>
      <div class="col-md-4">{{ "pdp.additionalDetails" | cxTranslate }}</div>
    </div>
    <hr class="horizontal-line" *ngIf="product?.bomProductList?.length > 0" />
    <div *ngFor="let bomProduct of product?.bomProductList">
      <vs-bom-product
        [product]="bomProduct"
        [availableAt]="product?.plantAvailableAt"
        [defaultSalesArea]="bomProduct?.defaultSalesArea"
        [checked]="allChecked"
        [catalog]="true"
        (bomProduct)="getProduct($event)"
      ></vs-bom-product>
    </div>
    <hr
      class="horizontal-line"
      *ngIf="product?.nonCatalogBomProducts?.length > 0"
    />
    <div *ngFor="let bomProduct of product?.nonCatalogBomProducts">
      <vs-bom-product [product]="bomProduct" [catalog]="false"></vs-bom-product>
    </div>
    <div class="BOM-button-group row">
      <div class="col-md-1"></div>
      <div
        class="col-md-2 mr30"
        *ngIf="
          loggedIn &&
          product.price.value &&
          !product?.obsoleteProductFlag &&
          product?.sellabilityFlag
        "
      >
        <button class="vs-primary-btn" (click)="addBOMToCart()">
          <span class="material-icons"> add_shopping_cart </span>

          {{ "pdp.buy" | cxTranslate }}
        </button>
      </div>

      <div
        *ngIf="
          loggedIn &&
          product.price.value &&
          !product?.obsoleteProductFlag &&
          product?.sellabilityFlag
        "
      ></div>
      <div
        class="col-md-2"
        *ngIf="
          (product.obsoleteProductFlag &&
            (!product.replacementProductUrl ||
              product.replacementProductUrl == '')) ||
          (product?.quotabilityFlag && loggedIn) ||
          !loggedIn
        "
      >
        <button
          class="button-width btn vs-tertiary-btn mr30"
          (click)="addBOMQuote()"
        >
          <span class="material-icons"> receipt </span>

          {{ "pdp.getAQuote" | cxTranslate }}
        </button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loading>
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
</ng-template>
